module.exports = __webpack_public_path__ + "static/img/1061.a3df3ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1061.jpg
// module id = 243
// module chunks = 0